<template>
  <transition>
    <svg class="spinner"
         :class="{ show: show }"
         v-if="show"
         :width="size" :height="size"
          viewBox="0 0 44 44">
      <circle class="path" :style="spinnerStyle" fill="none" stroke-width="4" stroke-linecap="round" cx="22" cy="22" r="20"></circle>
    </svg>
  </transition>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    show: Boolean,
    size: {
      type: String,
      default: '44px'
    },
    color: {
      type: String,
      default: '#db4437'
    }
  },
  computed: {
    spinnerStyle () {
      return {
        height: this.size,
        width: this.size,
        stroke: this.color
      }
    }
  }
}
</script>

<style lang="scss">
$offset: 126;
$duration: 1.4s;

.spinner {
  transition: opacity .15s ease;
  animation: rotator $duration linear infinite;
  animation-play-state: paused;
  &.show {
    animation-play-state: running;
  }
  &.v-enter, &.v-leave-active {
    opacity: 0.5;
  }
  &.v-enter-active, &.v-leave {
    opacity: 1;
  }
  .path {
    stroke-dasharray: $offset;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: dash $duration 0s infinite linear;
  }
}

@keyframes rotator {
  0% {
    transform: scale(0.5) rotate(0deg);
  }
  50% {
    transform: scale(0.5) rotate(180deg);
  }
  100% {
    transform: scale(0.5) rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: ($offset/10);
    transform: rotate(0deg)
  }
  50% {
    stroke-dashoffset: ($offset/5);
    transform: rotate(135deg)
  }
  100% {
    transform: rotate(270deg);
  }
}
</style>
